import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { config } from '../utils/config';
import FetchUserDetails from '../services/FetchUserDetails';
import './LoginPage.css';

function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  // Set page title
  useEffect(() => {
    document.title = 'CR Capability Index - Sign In';
  }, []);

  // Capture tokens from query string (after SSO) and redirect to Home
  useEffect(() => {
    console.log('🔍 LoginPage useEffect triggered');
    console.log('🔍 Current location:', location.pathname);
    console.log('🔍 Current search:', location.search);
    
    const params = new URLSearchParams(location.search);
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');
    
    console.log('🔍 Access token present:', !!accessToken);
    console.log('🔍 Refresh token present:', !!refreshToken);
    
    if (accessToken && refreshToken) {
      console.log('🔑 Tokens received from SSO callback:');
      console.log('Access Token:', accessToken.substring(0, 50) + '...');
      console.log('Refresh Token:', refreshToken.substring(0, 50) + '...');
      
      // Store tokens in session storage
      sessionStorage.setItem('access_token', accessToken);
      sessionStorage.setItem('refresh_token', refreshToken);
      
      console.log('✅ Tokens stored in session storage');
      console.log('Session Storage access_token:', sessionStorage.getItem('access_token') ? 'Present' : 'Missing');
      console.log('Session Storage refresh_token:', sessionStorage.getItem('refresh_token') ? 'Present' : 'Missing');
      
      // Clear URL parameters
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
      console.log('🧹 URL parameters cleared');
      
      // Fetch user details and redirect to Home
      const handleRoleBasedRedirect = async () => {
        try {
          console.log('🔄 Fetching user details for role-based redirect...');
          const success = await FetchUserDetails();
          
          if (success) {
            console.log('🏠 Redirecting to Home page');
            navigate('/Home', { replace: true });
          } else {
            console.error('❌ Failed to fetch user details');
            // Still redirect to Home even if user details fetch fails
            navigate('/Home', { replace: true });
          }
        } catch (error) {
          console.error('❌ Error during role-based redirect:', error);
          // Still redirect to Home even if there's an error
          navigate('/Home', { replace: true });
        }
      };
      
      handleRoleBasedRedirect();
      return;
    }

    // If already authenticated, go Home
    const existing = sessionStorage.getItem('access_token');
    if (existing) {
      console.log('🔐 User already authenticated, redirecting to Home');
      navigate('/Home', { replace: true });
      return;
    }
    
    // No tokens found, show login page
    setIsLoading(false);
  }, [location.search, navigate]);

  const handleSSO = () => {
    console.log('🚀 Initiating SSO login...');
    console.log('🔍 Config available:', !!config);
    console.log('🔍 Login URL:', config.loginUrl);
    console.log('🔍 Window._env_ available:', !!window._env_);
    console.log('🔍 Window._env_ content:', window._env_);
    
    try {
      const ssoUrl = config.loginUrl;
      console.log('🔗 Redirecting to SSO URL:', ssoUrl);
      window.location.href = ssoUrl;
    } catch (error) {
      console.error('❌ Error getting SSO URL:', error);
      // Fallback to hardcoded URL
      const fallbackUrl = 'http://localhost:5050/api/login';
      console.log('🔄 Using fallback URL:', fallbackUrl);
      window.location.href = fallbackUrl;
    }
  };

  // Show nothing while checking authentication to prevent flash
  if (isLoading) {
    return null;
  }

  return (
    <div className="login-page">
      <div className="login-card" role="dialog" aria-labelledby="login-heading" aria-modal="true">
        <div className="login-left">
          <img
            className="cr-logo"
            src="/crlogodark.png"
            alt="CriticalRiver logo"
          />
          <p className="tagline">Empowering Capability Excellence.</p>
        </div>
        <div className="login-right">
          <h1 id="login-heading" className="login-title">Sign in to Capability Index</h1>
          <div className="login-form">
            <button className="btn btn-sso" type="button" onClick={handleSSO} aria-label="Sign in with Microsoft">
              <img className="sso-icon" src="/microsoft-logo.svg" alt="Microsoft logo" />
              Sign in with Microsoft
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;


